<!--
 * @Description  : 电子保函 -> 开函申请
 * @Author       : zcc
 * @Date         : 2023-02-06
 * @LastEditors  : 王帅
 * @LastEditTime : 2025-10-14 16:22:39
 * @FilePath     : \ngs_platform_manage_admin\src\views\operation-management\bh\bh-letter-application\index.vue
-->
<template>
	<div class="bh-main operation-layout" :class="{ pd0: !routeQuery }">
		<!-- 列表查询页 -->
		<filter-layout @search="doSearch" @reset="doReset" v-if="!routeQuery" hasMore>
			<template #filter>
				<el-form class="flex-row-form colspan-4" size="small" ref="searchRef" :model="searchForm" label-width="130px">
					<el-form-item label="申请单位" prop="enterpriseName">
						<el-input :placeholder="'请输入'" clearable v-model="searchForm.enterpriseName"> </el-input>
					</el-form-item>
					<el-form-item label="统一社会信用代码" prop="creditCode">
						<el-input :placeholder="'请输入'" clearable v-model="searchForm.creditCode"> </el-input>
					</el-form-item>
					<el-form-item label="标段名称" prop="bidName">
						<el-input :placeholder="'请输入'" clearable v-model="searchForm.bidName"> </el-input>
					</el-form-item>
					<el-form-item label="标段编号" prop="bidNo">
						<el-input :placeholder="'请输入'" clearable v-model="searchForm.bidNo"> </el-input>
					</el-form-item>
				</el-form>
			</template>
			<template #more>
				<el-form class="flex-row-form colspan-4" size="small" ref="searchRef" :model="searchForm" label-width="130px">
					<el-form-item label="保函类型" prop="businessType">
						<el-select v-model="searchForm.businessType" :placeholder="'请选择'" clearable>
							<el-option
								v-for="(item, index) in businessTypeList"
								:key="'businessType' + index"
								:value="item.value"
								:label="item.label"
							></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="开函状态" prop="openStatus">
						<el-select v-model="searchForm.openStatus" :placeholder="'请选择'" clearable>
							<el-option
								v-for="(item, index) in openStatusList"
								:key="'openStatus' + index"
								:value="item.value"
								:label="item.label"
							></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="申请时间" prop="dateArr" class="date-time">
						<el-date-picker
							v-model="searchForm.dateArr"
							type="daterange"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							value-format="yyyy-MM-dd"
						></el-date-picker>
					</el-form-item>
				</el-form>
			</template>
			<template #content>
				<!-- 非请求参数 正常查看 -->
				<div class="operation-main">
					<div class="operation-header">
						<div class="title">
							合计开函申请记录：<span class="blue">{{ tableObj.total }}</span> 个
						</div>
						<div class="btnGroups"></div>
					</div>
					<div class="operation-container w-table-layout w-table-page">
						<div class="w-table-content" v-show="tableShow">
							<el-table
								ref="xTable"
								:data="tableObj.data"
								highlight-current-row
								height="100%"
								size="mini"
								border
								auto-resize
								resizable
								highlight-hover-row
								:loading="loading"
								show-overflow="tooltip"
								show-header-overflow="tooltip"
							>
								<el-table-column type="index" label="" width="50" align="center"> </el-table-column>
								<el-table-column prop="id" label="业务流水号" align="center" width="160" show-overflow-tooltip> </el-table-column>
								<el-table-column
									prop="enterpriseName"
									label="申请开函单位"
									align="center"
									width="160"
									show-overflow-tooltip
								></el-table-column>
								<el-table-column
									prop="creditCode"
									label="统一社会信用代码"
									align="center"
									width="180"
									show-overflow-tooltip
								></el-table-column>
								<el-table-column prop="bidName" label="标段名称" align="center" width="120" show-overflow-tooltip></el-table-column>
								<el-table-column prop="bidNo" label="标段编号" width="120" align="center" show-overflow-tooltip></el-table-column>
								<el-table-column prop="guaranteeAmount" label="保函申请金额（元）" width="159" align="center" show-overflow-tooltip>
								</el-table-column>
								<el-table-column prop="businessType" label="保函类型" width="100" align="center" show-overflow-tooltip>
									<template slot-scope="scope">
										<span v-if="scope.row.businessType == '01'">投标保函</span>
										<span v-else-if="scope.row.businessType == '02'">政采保函</span>
										<span v-else-if="scope.row.businessType == '03'">履约保函</span>
									</template>
								</el-table-column>
								<el-table-column prop="applyUserName" label="申请人" width="80" align="center" show-overflow-tooltip>
								</el-table-column>
								<el-table-column
									prop="createDate"
									label="申请时间"
									width="150"
									align="center"
									show-overflow-tooltip
								></el-table-column>
								<el-table-column
									prop="sysSourceName"
									label="业务来源"
									width="100"
									align="center"
									show-overflow-tooltip
								></el-table-column>
								<el-table-column prop="admittanceState" label="准入状态" width="100" align="center" show-overflow-tooltip>
									<template slot-scope="scope">
										<span v-if="scope.row.admittanceState == '0'" class="status-img">
											<img src="../../../../assets/images/fail.png" alt="" />
											准入失败
										</span>
										<span v-else class="status-img">
											<img src="../../../../assets/images/success.png" alt="" />
											已准入
										</span>
									</template>
								</el-table-column>
								<el-table-column prop="openStatus" label="开函状态" width="100" align="center" show-overflow-tooltip>
									<template slot-scope="scope">
										<span v-if="scope.row.openStatus == '1'">
											<img src="../../../../assets/images/between.png" alt="" />
											审核中
										</span>
										<span v-else-if="scope.row.openStatus == '2'">
											<img src="../../../../assets/images/success.png" alt="" />
											已开函
										</span>
										<span v-else-if="scope.row.openStatus == '3'">
											<img src="../../../../assets/images/success.png" alt="" />
											已解保
										</span>
										<span v-else-if="scope.row.openStatus == '4'">
											<img src="../../../../assets/images/fail.png" alt="" />
											已拒绝
										</span>
										<span v-else-if="scope.row.openStatus == '5'">
											<img src="../../../../assets/images/fail.png" alt="" />
											已撤销
										</span>
										<span v-else>-</span>
									</template>
								</el-table-column>
								<el-table-column align="center" width="100">
									<template slot="header">操作</template>
									<!-- v-if="roleBtns.includes('memberDetail')" -->
									<template slot-scope="scope">
										<el-button type="primary" size="small" round plain class="table-btn" @click="showDetail(scope.row)">
											<svg-icon icon-class="form-details"></svg-icon>
											详情
										</el-button>
									</template>
								</el-table-column>
							</el-table>
						</div>
						<div class="w-table-footer">
							<el-pagination
								@size-change="handleSizeChange"
								@current-change="handleCurrentChange"
								:current-page="tableObj.currentPage"
								:page-size="tableObj.pageSize"
								:total="tableObj.total"
								layout="total, sizes, prev, pager, next, jumper"
							>
							</el-pagination>
						</div>
					</div>
				</div>
			</template>
		</filter-layout>

		<!-- 详情页 -->
		<template v-else>
			<memberDetail ref="memberDetail"></memberDetail>
		</template>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import memberDetail from './components/detail'
import * as API from 'api/modules/bh/bh-letter-application'
export default {
	name: 'bh-letter-application-index',
	components: {
		memberDetail
	},
	data() {
		return {
			btnLoading: false,
			searchToggle: true,
			tableShow: true,
			//会员类型下拉信息
			accountTypeDL: [],
			//证件类型
			certTypeDL: [],

			searchForm: {
				enterpriseName: '', //申请单位
				creditCode: '', //统一社会信用代码
				bidName: '', //标段名称
				bidNo: '', //标段编号
				businessType: '', //保函类型
				openStatus: '', //开函状态
				dateArr: [],
				applyDataStart: null,
				applyDataEnd: null
			},
			tableObj: {
				data: [],
				currentPage: 1, // 当前页码
				pageList: [10, 20, 50, 100], // 显示条数数组
				pageSize: 10, // 当前显示条数
				total: 0 // 当前总条数
			},

			businessTypeList: [
				{
					label: '全部',
					value: ''
				},
				{
					label: '投标保函',
					value: '01'
				},
				{
					label: '政采保函',
					value: '02'
				},
				{
					label: '履约保函',
					value: '03'
				}
			], //保函类型
			openStatusList: [
				{
					label: '全部',
					value: ''
				},
				{
					label: '审核中',
					value: 1
				},
				{
					label: '已开函',
					value: 2
				},
				{
					label: '已解保',
					value: 3
				},
				{
					label: '已拒绝',
					value: 4
				},
				{
					label: '已撤销',
					value: 5
				}
			] //开函状态
		}
	},
	watch: {
		// 监听 筛选元素的 切换展示 重新调整表格高度
		searchToggle() {
			this.tableShow = false
			setTimeout(() => {
				this.tableShow = true
			}, 50)
			setTimeout(() => {
				this.$refs.xTable.doLayout()
			}, 1000)
		}
	},
	computed: {
		...mapState('app', { isBack: (state) => state.isBack }),
		...mapState('menu', {
			roleBtns: (state) => state.roleBtns
		}),
		routeQuery() {
			return this.$route.query.type
		}
	},
	created() {
		// 如果是 返回的
		if (this.isBack) {
			if (this.$getSessionItem('params')) {
				let params = JSON.parse(this.$getSessionItem('params'))
				Object.keys(this.searchForm).forEach((key) => (this.searchForm[key] = params[key]))
				this.tableObj.currentPage = params.currentPage
				this.tableObj.pageSize = params.pageSize

				// 移除 避免污染
				this.$removeSessionItem('params')
			}
		}
		this.getSelectBhList()
	},
	methods: {
		//查询
		doSearch() {
			this.getSelectBhList()
		},
		//获取分页列表信息
		getSelectBhList() {
			this.tableObj.data = []
			if (this.searchForm.dateArr && this.searchForm.dateArr.length > 0) {
				this.searchForm.applyDataStart = this.searchForm.dateArr[0] + ' 00:00:00'
				this.searchForm.applyDataEnd = this.searchForm.dateArr[1] + ' 23:59:59'
			} else {
				this.searchForm.applyDataStart = ''
				this.searchForm.applyDataEnd = ''
			}
			let param = Object.assign({}, this.searchForm)
			param.current = this.tableObj.currentPage
			param.size = this.tableObj.pageSize
			this.loading = true
			API.getSelectBhList(param).then((res) => {
				if (res.operationCode == 1) {
					this.tableObj.data = res.data.records
					this.tableObj.total = parseInt(res.data.total)
					this.loading = false
				}
			})
		},
		//重置查询
		doReset() {
			Object.keys(this.searchForm).forEach((key) => (this.searchForm[key] = ''))
			this.searchForm.applyDataStart = null
			this.searchForm.applyDataEnd = null
			this.searchForm.dateArr = []
			this.tableObj.pageSize = 10
			this.tableObj.currentPage = 1
			this.getSelectBhList()
		},
		//操作-详情
		showDetail(row) {
			let params = Object.assign({}, this.searchForm)
			params.currentPage = this.tableObj.currentPage
			params.pageSize = this.tableObj.pageSize
			this.$setSessionItem('params', JSON.stringify(params))

			this.$router.push({
				path: 'bh-letter-application-index',
				query: {
					type: 'memberDetail',
					id: row.id
				}
			})
		},
		// 切换显示条数
		handleSizeChange(val) {
			this.tableObj.pageSize = val
			this.getSelectBhList()
		},
		//切换当前页码
		handleCurrentChange(val) {
			this.tableObj.currentPage = val
			this.getSelectBhList()
		},
		// 是否展开搜索区域
		changeState() {
			this.searchToggle = !this.searchToggle
		},
		// 返回
		goBack() {
			this.$router.push({ path: '/bh-letter-application-index' })
		}
	}
}
</script>

<style lang="less" scoped>
.bh-main {
	&.pd0 {
		padding: 0;
	}
	.filter-box {
		padding-top: 5px;
	}

	/deep/ .search-form {
		.el-col {
			height: 48px;
		}

		.text-center {
			display: flex;
			align-items: center;
			justify-content: center;
		}
	}

	.blue-text {
		color: #2671cc;
		cursor: pointer;
	}

	.blue-text:hover {
		color: blue;
	}

	.el-switch.is-disabled {
		opacity: 1;
	}

	/deep/ .el-switch.is-disabled .el-switch__core,
	/deep/ .el-switch.is-disabled .el-switch__label {
		cursor: pointer !important;
	}
}
.w-table-content {
	/deep/ .el-radio__label {
		display: none;
	}
}
.label-tooltip {
	max-width: 600px;
	max-height: 140px;
	overflow-y: auto;
	overflow-x: hidden;
}

.primary-dialog {
	/deep/ .el-dialog__body {
		padding: 30px;
	}

	.row-label {
		height: 40px;
		line-height: 40px;
		padding-right: 15px;
	}

	.row-btn {
		padding-left: 10px;
		width: 100%;
	}

	.tags-container {
		line-height: 40px;
		max-height: 120px;
		overflow-y: auto;

		/deep/ .el-tag {
			cursor: pointer;
		}
	}

	.tags-all-container {
		line-height: 30px;
		max-height: 300px;
		overflow-y: auto;

		/deep/ .el-tag {
			cursor: pointer;
		}
	}
}

.status {
	.switch > .el-switch__label--right > span {
		margin-left: 0 !important;
		margin-right: 15px !important;
	}
}

.status-img {
	display: flex;
	align-items: center;
	justify-content: center;

	img {
		margin-right: 5px;
	}
}
</style>
